import { type RootState } from '../../../lib/store';
import { BATCH_PROGRESS_TAB_OPTIONS } from '../constants';

export const selectSelectedProjectId = (state: RootState) =>
  state.metrics?.selectedProjectId || null;

export const selectSelectedAnnotatorId = (state: RootState) =>
  state.metrics?.selectedAnnotatorId || null;

export const selectSelectedBatchwiseProgressTab = (state: RootState) =>
  state.metrics?.selectedBatchwiseProgressTab || BATCH_PROGRESS_TAB_OPTIONS[0];

export const selectBatchwiseProgressStartDate = (state: RootState) =>
  state.metrics?.batchWiseStartDate ?? null;

export const selectBatchwiseProgressEndDate = (state: RootState) =>
  state.metrics?.batchWiseEndDate ?? null;

export const selectSummaryBatchTypeId = (state: RootState) =>
  state.metrics?.summaryBatchTypeId || null;

export const selectSummaryStartDate = (state: RootState) => state.metrics?.summaryStartDate ?? null;

export const selectSummaryEndDate = (state: RootState) => state.metrics?.summaryEndDate ?? null;

export const selectEncounterStatsBatchTypeId = (state: RootState) =>
  state.metrics?.encounterStatsBatchTypeId || null;

export const selectEncounterStatsStartDate = (state: RootState) =>
  state.metrics?.encounterStatsStartDate ?? null;

export const selectEncounterStatsEndDate = (state: RootState) =>
  state.metrics?.encounterStatsEndDate ?? null;

export const selectIRRFilterTypeId = (state: RootState) => state.metrics?.irrFilterTypeId || null;

export const selectIRRScoreDate = (state: RootState) => state.metrics?.irrScoreDate ?? null;

export const selectIRRScoreBatchTypeId = (state: RootState) =>
  state.metrics?.irrScoreBatchTypeId || null;

export const selectIRRCardFilters = (state: RootState) => state.metrics?.irrCardFilters ?? null;

export const selectSummaryTablePage = (state: RootState) => state.metrics?.summaryTablePage ?? 0;
export const selectSummaryTablePageSize = (state: RootState) =>
  state.metrics?.summaryTablePageSize ?? 25;

export const selectEncounterStatsTablePage = (state: RootState) =>
  state.metrics?.encounterStatsTablePage ?? 0;
export const selectEncounterStatsTablePageSize = (state: RootState) =>
  state.metrics?.encounterStatsTablePageSize ?? 25;

export const selectIRRScoreTablePage = (state: RootState) => state.metrics?.irrScoreTablePage ?? 0;
export const selectIRRScoreTablePageSize = (state: RootState) =>
  state.metrics?.irrScoreTablePageSize ?? 25;

export const selectBatchProgressTablePage = (state: RootState) =>
  state.metrics?.batchProgressTablePage ?? 0;
export const selectBatchProgressTablePageSize = (state: RootState) =>
  state.metrics?.batchProgressTablePageSize ?? 25;

export const selectHolidaysTablePage = (state: RootState) => state.metrics?.holidaysTablePage ?? 0;
export const selectHolidaysTablePageSize = (state: RootState) =>
  state.metrics?.holidaysTablePageSize ?? 25;
